"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _createStyles = require("../styles/createStyles");
var _system = require("../system/");
var _TypographyBase = _interopRequireDefault(require("../TypographyBase"));
const _excluded = ["component", "classes", "className", "lead", "noWrap", "size"];
const useStyles = (0, _createStyles.createStyles)(() => ({
  root: {},
  /* Styles applied to the root element if `nowrap={true}`. */
  noWrap: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }
}));
const getSizeKey = (size, lead) => {
  return lead ? `${size}Lead` : size;
};
const getSizeOrLeadSize = (sizes, lead) => {
  if (Array.isArray(sizes)) {
    return sizes.map(size => getSizeKey(size, lead));
  }
  if ((0, _system.isBreakpointObject)(sizes)) {
    const results = {};
    const sizesKeys = Object.keys(sizes);
    sizesKeys.forEach(breakpoint => {
      results[breakpoint] = getSizeKey(sizes[breakpoint], lead);
    });
    return results;
  }
  return getSizeKey(sizes, lead);
};

/**
 * **❗️ DEPRECATED**: Use the new `Text` component from `@busbud/horizon` - [Storybook](https://main--66e336a480b3d19fa782310f.chromatic.com/?path=/docs/typography-link--docs):
 *
 * ```tsx
 * import { Text } from "@busbud/horizon";
 * ```
 *
 *  [Storybook](https://busbud.github.io/horizon-web-ui-kit/?path=/docs/typography-text)
 *
 * @deprecated
 */
const Text = props => {
  const {
      component = 'p',
      classes: classesOverrides,
      className,
      lead = false,
      noWrap = false,
      size = 'md'
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  const {
    classes,
    cx
  } = useStyles({
    classesOverrides
  });
  const classNames = cx(classes.root, className, {
    [classes.noWrap]: noWrap
  });
  return /*#__PURE__*/_react.default.createElement(_TypographyBase.default, (0, _extends2.default)({
    component: component,
    className: classNames,
    size: getSizeOrLeadSize(size, lead),
    type: "text"
  }, other));
};
var _default = exports.default = Text;